/**
 * 大po
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/9      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from "react";
import PropTypes from "prop-types";
import "./index.less";
import SmallPo from "../SmallPo";
import {
    numberWithCommas,
    toFixedWithCommas,
} from "../../../../utils/number-util";
import PriceComposition from "../PriceComposition";
import dayjs from "dayjs";
import Locale from "../../../../utils/locale";
let locale = Locale.current();
class BigPo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //是否展示更多
            isShowMore: false,
            //数据源
            model: props.model,
            nowTime: props.nowTime,
            //倒计时
            countdown: {
                DD: "-",
                HH: "-",
                MM: "-",
                SS: "-",
            },
        };
        this.stateList = {
            0: __getServerLanguage("DaiZhiFuDingJin"),
            1: __getServerLanguage("JinXingZhong"),
            2: __getServerLanguage("DaiZhiFuWeiKuan"),
            3: __getServerLanguage("YiWanCheng"),
            4: __getServerLanguage("YiQuXiao"),
        };
        this.countDownTime = null;
    }

    setCountTime(nowDate, endDate) {
        if (nowDate >= endDate) {
            let model = this.state.model;
            model.status = 4;
            this.setState({
                model: model,
            });
            return false;
        }
        //时间差
        var leftTime = endDate - nowDate;
        //定义变量 d,h,m,s保存倒计时的时间
        var d, h, m, s;
        if (leftTime >= 0) {
            d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
            h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
            m = Math.floor((leftTime / 1000 / 60) % 60);
            s = Math.floor((leftTime / 1000) % 60);
        }
        this.setState(
            {
                countdown: {
                    DD: d,
                    HH: h,
                    MM: m,
                    SS: s,
                },
            },
            () => {
                clearTimeout(this.countDownTime);
                this.countDownTime = setTimeout(() => {
                    nowDate = nowDate + 1000;
                    this.setCountTime(nowDate, endDate);
                }, 1000);
            }
        );
    }

    showMore() {
        this.setState({
            isShowMore: !this.state.isShowMore,
        });
    }

    componentDidMount() {
        this.initCountDown();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            model: nextProps.model,
            nowTime: nextProps.nowTime,
        });
        this.initCountDown();
    }

    /**
     * 初始化倒计时
     */
    initCountDown() {
        //倒计时初始化
        if (
            (this.state.model.status === 0 || this.state.model.status === -1) &&
            this.state.model.deposit > 0 &&
            this.state.model.endTime &&
            this.state.model.endTime > this.state.nowTime
        ) {
            //开始倒计时
            this.setCountTime(this.state.nowTime, this.state.model.endTime);
        }
    }

    render() {
        let state = this.state;
        let { isShowMore, model } = this.state;
        let ids = [];
        if (model.itemList && model.itemList.length > 0) {
            for (var i = 0; i < model.itemList.length; i++) {
                ids.push(model.itemList[i].id);
            }
        }
        return (
            <div
                className={`po-card-wrap ${model.status === 4 ? "cancel" : ""}`}
            >
                <div className="po-card-sign">
                    <div>
                        <p className="po-code">
                            {__getServerLanguage("DingDan")}:{model.code}
                        </p>
                        <p className="time">
                            {__getServerLanguage("XiaDanShiJian")}:{" "}
                            {dayjs(model.createTime).format(
                                "YYYY-MM-DD HH:mm:ss"
                            )}
                        </p>
                    </div>
                    <span className="big-triangle"></span>
                    <span className="small-triangle"></span>
                </div>
                <div className="po-card-head-wrap">
                    {/*待支付尾款*/}
                    {model.status === 2 ? (
                        <div className="text-right">
                            <p className="status-tip">
                                {__getServerLanguage("DaiZhiFuTiHuo")}
                            </p>
                        </div>
                    ) : null}

                    {/*待支付*/}
                    {
                        // 待支付的定金大于0
                        (model.status === 0 || model.status === -1) &&
                        model.deposit > 0 ? (
                            <div className="text-right">
                                <p className="status-tip">
                                    <span>
                                        {__getServerLanguage("DingJin")}:{" "}
                                        {model.currencySymbol}{" "}
                                        {numberWithCommas(
                                            toFixedWithCommas(model.deposit, 2)
                                        )}
                                    </span>
                                </p>
                                {
                                    // 当前时间是否大于结束时间，如果大于的话时间就不显示了
                                    this.state.model.endTime &&
                                    this.state.model.endTime >
                                        this.state.nowTime ? (
                                        <p className="time-tip">
                                            {__getServerLanguage("ShengYu")}
                                            &nbsp; &nbsp; {
                                                state.countdown.DD
                                            }{" "}
                                            {__getServerLanguage("TianS")}&nbsp;
                                            &nbsp;{state.countdown.HH}{" "}
                                            {__getServerLanguage("Shi2")}&nbsp;
                                            &nbsp;{state.countdown.MM}{" "}
                                            {__getServerLanguage("Fen")}&nbsp;
                                            &nbsp;{state.countdown.SS}{" "}
                                            {__getServerLanguage("Miao")}&nbsp;
                                        </p>
                                    ) : null
                                }
                            </div>
                        ) : null
                    }

                    {/*装柜完成*/}
                    {model.status === 3 ? (
                        <div className="text-right only-status-tip-wrap">
                            <p className="status-tip success">
                                <span>
                                    {__getServerLanguage(
                                        "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA2=="
                                    )}
                                </span>
                            </p>
                        </div>
                    ) : null}

                    {/*进行中 or 已取消*/}
                    {model.status === 1 || model.status === 4 ? (
                        <div className="text-right only-status-tip-wrap">
                            <p className="status-tip">
                                <span>
                                    {this.stateList[Number(model.status)] ||
                                        "-"}
                                </span>
                            </p>
                        </div>
                    ) : null}

                    {
                        model.status==5?
                            <div className="text-right">
                                <p className="status-tip">
                                    <span>
                                        {__getServerLanguage('DinDanJinE')}: {model.currencySymbol} {numberWithCommas(toFixedWithCommas(model.actualTotalPrice,2))}
                                    </span>
                                </p>
                                {
                                    // 当前时间是否大于结束时间，如果大于的话时间就不显示了
                                    this.state.model.endTime&&this.state.model.endTime>this.state.nowTime?
                                        <p className="time-tip">
                                            {__getServerLanguage('ShengYu')}&nbsp;
                                            &nbsp; {state.countdown.DD} {__getServerLanguage('TianS')}&nbsp;
                                            &nbsp;{state.countdown.HH} {__getServerLanguage('Shi2')}&nbsp;
                                            &nbsp;{state.countdown.MM} {__getServerLanguage('Fen')}&nbsp;
                                            &nbsp;{state.countdown.SS} {__getServerLanguage('Miao')}&nbsp;
                                        </p>
                                        :
                                        null
                                }
                            </div>
                            :
                            null
                    }

                    <div className="text-right mt_10">
                        {
                            (model.cancelRefundTotal&&!model.refundDescribeType)?
                                <p className="color-danger">{__getServerLanguage('YiTuiKuan')} {model.currencySymbol} {numberWithCommas(toFixedWithCommas(model.cancelRefundTotal,2))}</p>
                                :
                                null
                        }
                        {
                            model.refundDescribeType?
                                <p className="color-danger">{__getServerLanguage(model.refundDescribeType)}</p>
                                :
                                null
                        }
                    </div>
                </div>

                <div className="base-info">
                    <div style={{ width: "700px" }}>
                        <p>
                            +{model.telCode} {model.consigneeMonde}
                        </p>
                        {locale !== "zh" ? (
                            <span>
                                {model.country}&nbsp;
                                {model.consigneeAddress}&nbsp;
                                {model.city}
                            </span>
                        ) : (
                            <span>
                                {model.country}&nbsp;
                                {model.city}&nbsp;
                                {model.consigneeAddress}
                            </span>
                        )}
                    </div>
                    <div className="text-right">
                        <p>
                            <span>
                                {model.currencySymbol}{" "}
                                {numberWithCommas(
                                    toFixedWithCommas(model.actualTotalPrice, 2)
                                ) || "-"}
                            </span>
                            <span className="margin-left-5">
                                <PriceComposition
                                    model={model}
                                    totalPrice={model.actualTotalPrice}
                                >
                                    <i className="iconfont icon-down btn-link"></i>
                                </PriceComposition>
                            </span>
                        </p>
                    </div>
                </div>

                {/*提示*/}

                {/*{model.status === 0 || model.status === -1 ? (
                    <p className="color-danger util-font-14 margin-bottom-10">
                        {__getServerLanguage("QingJinKuaiZhiFuDingJinYuJiDao")}
                    </p>
                ) : null}*/}

                {/*{model.itemList && model.itemList.length > 1 ? (
                    <div className="explain">
                        <span className="iconfont icon-xinxix margin-right-5"></span>
                        <span>
                            {__getServerLanguage(
                                "YouYuShangPinDeHuoQiBuTong",
                                `${model.itemList && model.itemList.length}`
                            )}
                        </span>
                    </div>
                ) : null}*/}

                {/*小po列表*/}
                <div className="more-wrap">
                    {(model.itemList || []).map(function (item, index) {
                        return (
                            <div
                                key={index}
                                style={{
                                    display:
                                        index <= 2 || isShowMore
                                            ? "block"
                                            : "none",
                                }}
                            >
                                <SmallPo
                                    model={item}
                                    bigPoModel={model}
                                    status={model.status}
                                    isHideTitle={
                                        model.itemList &&
                                        model.itemList.length <= 1
                                    }
                                ></SmallPo>
                            </div>
                        );
                    })}
                </div>

                {/*查看更多按钮*/}
                {model.itemList && model.itemList.length > 3 ? (
                    <div className="text-center more-btn-wrap">
                        <a
                            className="a-link"
                            onClick={this.showMore.bind(this)}
                        >
                            {this.state.isShowMore
                                ? __getServerLanguage("ShouQi")
                                : __getServerLanguage("ChaKanGengDuo")}
                            （{model.itemList.length}）
                        </a>
                    </div>
                ) : null}
            </div>
        );
    }
}

BigPo.defaultProps = {
    //po数据源
    model: {},
    nowTime: new Date().getTime(),
    callBack: function () {},
};

BigPo.propTypes = {
    model: PropTypes.object,
    nowTime: PropTypes.number,
    callBack: PropTypes.func,
};
export default BigPo;
